module.exports = __webpack_public_path__ + "images/d36ecf52cedbb3344d5936ca4ec35b44799cae7b679a668c28a93606d2be6c2a.svg";